import { RESOURCE_NAME } from '@esentai/core/features/parkingWhitelist/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadWhitelist = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateWhitelist = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateWhitelist = authorizeIf(canUpdate(RESOURCE_NAME));
